import { CommonEnums } from 'src/app/shared/common.enums';

export class Splt_Inst {
    splt_Inst_Id: number;
    dxMp_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    persistFlg: string;
    updateDt: Date;
    updateBy: string;
    lastUpdateBy: string;
    conditions_Tab_Valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.splt_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.persistFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.conditions_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
    }

    static parse(splt_InstTmp: Splt_Inst): Splt_Inst {
        let splt_Inst: Splt_Inst = new Splt_Inst();
        splt_Inst.copyFrom(splt_InstTmp);
        return splt_Inst;
    }
    getPrimaryKey(): string {
        return this.splt_Inst_Id + '.' + this.dxMp_Id;
    }


    copy(): Splt_Inst {
        let splt_InstTmp: Splt_Inst = new Splt_Inst();

        splt_InstTmp.splt_Inst_Id = this.splt_Inst_Id;
        splt_InstTmp.dxMp_Id = this.dxMp_Id;
        splt_InstTmp.nm = this.nm;
        splt_InstTmp.description = this.description;
        splt_InstTmp.ver = this.ver;
        splt_InstTmp.valid_Cd = this.valid_Cd;
        splt_InstTmp.persistFlg = this.persistFlg;
        splt_InstTmp.updateDt = this.updateDt;
        splt_InstTmp.updateBy = this.updateBy;
        splt_InstTmp.lastUpdateBy = this.lastUpdateBy;
        splt_InstTmp.conditions_Tab_Valid_Cd = this.conditions_Tab_Valid_Cd;

        return splt_InstTmp;
    }

    copyFrom(splt_InstTmp: Splt_Inst): void {
        this.splt_Inst_Id = splt_InstTmp.splt_Inst_Id;
        this.dxMp_Id = splt_InstTmp.dxMp_Id;
        this.nm = splt_InstTmp.nm;
        this.description = splt_InstTmp.description;
        this.ver = splt_InstTmp.ver;
        this.valid_Cd = splt_InstTmp.valid_Cd;
        this.persistFlg = splt_InstTmp.persistFlg;
        this.updateDt = splt_InstTmp.updateDt;
        this.updateBy = splt_InstTmp.updateBy;
        this.lastUpdateBy = splt_InstTmp.lastUpdateBy;
        this.conditions_Tab_Valid_Cd = splt_InstTmp.conditions_Tab_Valid_Cd;
    }

    compare(splt_InstTmp: Splt_Inst): string {
        let splt_InstString: string = this.toString(false);
        let splt_InstTmpString: string = splt_InstTmp.toString(false);

        if (splt_InstString != splt_InstTmpString) {
            return splt_InstString + ', ' + splt_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str:string= "Splt_Inst [splt_Inst_Id=" + this.splt_Inst_Id + ", dxMp_Id=" + this.dxMp_Id +
            ", nm=" + this.nm + ", description=" + this.description + ", ver=" + this.ver + ", valid_Cd=" + this.valid_Cd +
            ", persistFlg=" + this.persistFlg + ", updateDt=" + this.updateDt + ", updateBy=" + this.updateBy +
            ", lastUpdateBy=" + this.lastUpdateBy + ", conditions_Tab_Valid_Cd=" + this.conditions_Tab_Valid_Cd + "]";

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}

